export default "__VITE_ASSET__BbCq7ZbC__"